import React, {Component} from 'react';
import PropTypes from 'prop-types';

//Would like this to be stateless, but removing state means that every implementor would have to understand the internal logic of this component. Not worth it.
export default class EditOnHoverTextbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            toggled: false,
            text: props.text
        };

        this.toggle = this.toggle.bind(this);
        this.valueChanged = this.valueChanged.bind(this);
        this.blur = this.blur.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.setRef = this.setRef.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.text !== this.props.text) {
            this.setState({text: nextProps.text})
        }
    }

    toggle(event) {
        this.setState({toggled: !this.state.toggled});
        event.preventDefault();
        event.stopPropagation();
    }

    valueChanged(evt) {
        this.setState({text: evt.target.value});
    }

    handleKeyPress(evt) {
        if (evt.key === 'Enter') {
            this.childInput.blur()
        }
    }

    handleFocus(evt) {
        evt.target.select();
    }

    setRef(input) {
        this.childInput = input;
    }

    blur() {
        if (this.props.text !== this.state.text) {
            if(this.state.text.trim() === ""){
                this.setState({text: this.props.text});
            }else {
                if (this.props.onChange) {
                    this.props.onChange(this.state.text)
                } else {
                    alert("Missing required onChange property for EditOnHoverTextBox")
                }
            }
        }
        if (this.props.toggle) {
            this.setState({toggled: false});
        }
    }

    render() {
        return this.state.toggled
            ? <EditableText
                text={this.state.text}
                toggle={this.toggle}
                valueChanged={this.valueChanged}
                className={this.props.className}
                onBlur={this.blur}
                onKeyPress={this.handleKeyPress}
                onFocus={this.handleFocus}
                setRef={this.setRef}
                onClick={(event) => {event.preventDefault();event.stopPropagation();}}
            />
            : <PlainText
                text={this.state.text}
                toggle={this.toggle}
                className={this.props.className}
            />;
    }
}

const PlainText = props => {
    return (
        <div className="editable-text">
            <span
                className={`hover-editable ${props.className}`}
                onClick={props.toggle}>
                {props.text}
            </span>
        </div>
    );
};

const EditableText = props => {
    return (
        <div className="editable-text">
            <div className="hover-editable">
                <input
                    type="text"
                    className={`${props.className}`}
                    autoFocus={true}
                    onChange={props.valueChanged}
                    onBlur={() => {
                        props.onBlur();
                    }}
                    value={props.text}
                    onKeyPress={props.onKeyPress}
                    onFocus={props.onFocus}
                    ref={props.setRef}
                    onClick={props.onClick}
                />
            </div>
        </div>
    );
};

EditOnHoverTextbox.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    onBlur: PropTypes.func,
    toggle: PropTypes.func,
    albumId: PropTypes.number
};

PlainText.propTypes = {
    toggle: PropTypes.func,
    text: PropTypes.string,
    className: PropTypes.string
};

EditableText.propTypes = {
    valueChanged: PropTypes.func,
    toggle: PropTypes.func,
    text: PropTypes.string,
    className: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/common/components/edit-on-hover-textbox.jsx